module.exports = [
  {
    name: {
      zh: '麥錫光',
      en: 'KURMA MAC',
    },
    title: {
      zh: '',
      en: 'Coordinator for Macao Occupational Skills Recognition System and Hospitality Courses',
    },
    description: {
      zh: '職業技能認可基準及酒店課程主任麥錫光主任擁有逾15年的酒店及旅遊業工作經驗，於2002年加入旅遊學院，任職導師。作為澳門職業技能認可基準（MORS）的課程主任，他最近積極把基準引進到中國內地。',
      en: 'Mr. Mac has more than 15 years’ experience of working in hospitality and tourism. He joined IFT as an instructor in 2002. As coordinator of the Macao Occupational Skills Recognition System (MORS) courses, Mr. Mac has most recently been involved in efforts to bring MORS to Mainland China.',
    },
    image: '/images/hotel/team-01.jpg',
  },
  {
    name: {
      zh: '譚志輝',
      en: 'EDWYN TAM',
    },
    title: {
      zh: '餐飲課程主任',
      en: 'Coordinator for Food and Beverage Courses',
    },
    description: {
      zh: '譚志輝主任擁有逾25年餐飲工作經驗，於2005年加入旅遊學院。除了擔任餐飲課程導師外，他亦負責統籌安排國際認證課程，以及餐飲活動和比賽。',
      en: 'Mr. Tam joined IFT in 2005. He is an instructor with more than 25 years of experience of working in the food and beverage business. He also organises special internationally recognised courses, and special food and beverage events and competitions.',
    },
    image: '/images/hotel/team-02.jpg',
  },
  {
    name: {
      zh: '陳傳錢',
      en: 'MICHAEL CHAN',
    },
    title: {
      zh: '文化遺產及旅遊課程主任',
      en: 'Coordinator for Heritage and Tourism Courses',
    },
    description: {
      zh: '陳傳錢主任擁有中國內地華僑大學旅遊管理碩士學位，於1997年加入旅遊學院，曾於旅遊業服務長達十年，主要從事導遊工作。他目前在學院任教導遊課程，以及負責統籌組織世界文化遺產專業導賞員和文化遺產相關的專題講座。',
      en: 'Mr. Chan holds a master’s degree in Tourism Management from Huaqiao University in Mainland China. He joined IFT in 1997. Before joining IFT, he had worked in the tourism industry for a decade, where he started as a tour guide. He is currently an IFT instructor in the field of tourism. He is also in charge of the Specialist Guide for World Heritage Sites Programme and organises special talks on culture and heritage.',
    },
    image: '/images/hotel/team-03.jpg',
  },
  {
    name: {
      zh: '鄧靖宇',
      en: 'QUEENIE TANG',
    },
    title: {
      zh: '零售、會展及商業課程主任',
      en: 'Coordinator for Retail, Events and Business Courses',
    },
    description: {
      zh: '鄧靖宇主任是廣告、公共關係及零售管理領域的資深人士，擁有新加坡南洋理工大學大眾傳播碩士學位。2002年從事教職前，她曾於媒體及零售領域任職。她於2009年加入學院，現任職導師。',
      en: 'Ms. Tang specialises in advertising, public relations and retailing management. She earned her master’s degree in Mass Communication from Nanyang Technological University in Singapore. Before turning to teaching in 2002, Ms. Tang held positions in the media and in retailing. She joined IFT in 2009, and now working as an instructor at IFT.',
    },
    image: '/images/hotel/team-04.jpg',
  },
  {
    name: {
      zh: '傅曉棠',
      en: 'TINA FU',
    },
    title: {
      zh: '創意藝術及資訊科技課程主任',
      en: 'Coordinator for Creative Studies and IT Courses',
    },
    description: {
      zh: '傅曉棠主任是平面設計及創意藝術課程導師。她擁有澳門理工學院設計傳意學士學位，曾在多家市場策劃及廣告公司擔任平面設計師。2002年，她開始從事教育工作，2009年加入旅遊學院，近年更積極參與策劃創意與藝術課程的作品展覽工作。 ',
      en: 'Ms. Fu is an instructor on graphic design and the creative arts. She holds a bachelor’s degree in Graphic Communication awarded by the Macao Polytechnic Institute; she has worked as a graphic designer for several marketing and advertising firms. She joined IFT in 2009 after beginning her teaching career in 2002. In recent years, she has been actively involved in the organisation of exhibition events for the Creative studies courses.',
    },
    image: '/images/hotel/team-05.jpg',
  },
  {
    name: {
      zh: '陳詠心',
      en: 'VINITA CHAN',
    },
    title: {
      zh: '健康、美容及美療課程主任',
      en: 'Coordinator for Health, Spa and Beauty Courses',
    },
    description: {
      zh: '陳詠心主任自2002年加入旅遊學院，任教食物衛生及營養學課程。她曾在酒店業及教育領域工作。她擁有加拿大阿爾伯塔大學營養與食品科學學士學位、澳洲新英格蘭大學應用語言碩士學位，澳門大學頒發的學士後教育證書，以及國際認可的食品安全導師證書及監考員資格。',
      en: 'Ms. Chan has been at IFT since 2002 as a specialist lecturer in food hygiene and nutrition. She is an internationally certified food safety instructor and examination proctor. Ms. Chan’s experience includes employment in the areas of hospitality and education. She holds a bachelor’s degree in Nutrition and Food Sciences from the University of Alberta, Canada, and a master’s degree in Applied Linguistics from the University of New England, Australia. She also has received a Postgraduate Certificate in Education from the University of Macau.',
    },
    image: '/images/hotel/team-06.jpg',
  },
  {
    name: {
      zh: '胡詠斯',
      en: 'SARAH WU',
    },
    title: {
      zh: '語言課程主任',
      en: 'Coordinator for Language Courses',
    },
    description: {
      zh: '胡詠斯主任是資深的英語教師，曾為眾多不同人士教導各種課程，包括成人持續教育、中學生、警察，以及旅遊業、酒店業及其他行業的從業人員。她於2005年出任旅遊學院導師一職，擁有英國埃塞克斯大學應用語言碩士學位。',
      en: 'Ms. Wu is a seasoned teacher of English. She has taught courses to many different people, such as adults in continuing education, high school pupils, police officers and staff in hospitality, tourism and other industries. Ms. Wu joined IFT in 2005 as a lecturer. She gained her master’s degree in Applied Linguistics from the University of Essex, United Kingdom.',
    },
    image: '/images/hotel/team-07.jpg',
  },
]
